import { render } from "./TitleBarProp.vue?vue&type=template&id=4c4ec3b8&scoped=true"
import script from "./TitleBarProp.vue?vue&type=script&lang=js"
export * from "./TitleBarProp.vue?vue&type=script&lang=js"

import "./TitleBarProp.vue?vue&type=style&index=0&id=4c4ec3b8&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4ec3b8"]])

export default __exports__